import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function HQAudit() {
  const [items, setItems] = useState([]);
  const [action, setAction] = useState("");
  const [entity, setEntity] = useState("");
  const [severity, setSeverity] = useState("");

  const load = () => {
    const params = new URLSearchParams();
    if (action) params.set("action", action);
    if (entity) params.set("entity", entity);
    if (severity) params.set("severity", severity);
    api.get(`/hq/audit${params.toString() ? "?" + params.toString() : ""}`).then((r) => setItems(r.data || []));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [action, entity, severity]);

  return (
    <div className="p-6" data-testid="hq-audit">
      <p className="overline">Immutable-style audit</p>
      <h1 className="font-display text-3xl tracking-tighter mb-6">Audit Log</h1>
      <div className="flex gap-2 mb-4 flex-wrap items-center">
        <input placeholder="action (regex)" data-testid="hq-audit-action" value={action} onChange={(e) => setAction(e.target.value)}
               className="bg-transparent border border-cream/15 px-2 py-1 text-xs focus:border-gold outline-none" />
        <select data-testid="hq-audit-entity" value={entity} onChange={(e) => setEntity(e.target.value)}
                className="bg-transparent border border-cream/15 px-2 py-1 text-xs focus:border-gold outline-none">
          <option value="">any entity</option>
          <option value="dispute">dispute</option>
          <option value="safety">safety</option>
          <option value="verification">verification</option>
          <option value="booking">booking</option>
        </select>
        <select data-testid="hq-audit-severity" value={severity} onChange={(e) => setSeverity(e.target.value)}
                className="bg-transparent border border-cream/15 px-2 py-1 text-xs focus:border-gold outline-none">
          <option value="">any severity</option>
          <option value="info">info</option>
          <option value="high">high</option>
          <option value="critical">critical</option>
        </select>
        <p className="text-[10px] uppercase tracking-[0.2em] text-cream/50 ml-auto">{items.length} entries</p>
      </div>

      <div className="border border-cream/10 overflow-x-auto" data-testid="hq-audit-table">
        <table className="w-full text-xs">
          <thead className="bg-black/40 text-cream/60 uppercase tracking-[0.2em] text-[10px]">
            <tr>
              <th className="p-2 text-left">Time</th>
              <th className="p-2 text-left">Actor</th>
              <th className="p-2 text-left">Action</th>
              <th className="p-2 text-left">Entity</th>
              <th className="p-2 text-left">Reason</th>
              <th className="p-2 text-left">Severity</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="p-4 text-center text-cream/50">No audit entries.</td></tr>}
            {items.map((a) => (
              <tr key={a.id} className="border-t border-cream/10" data-testid={`hq-audit-row-${a.id}`}>
                <td className="p-2 font-mono text-[10px]">{new Date(a.at).toLocaleString()}</td>
                <td className="p-2">{a.actor_name} <span className="text-[10px] uppercase tracking-[0.2em] text-cream/50">({a.actor_role})</span></td>
                <td className="p-2 font-mono text-[10px]">{a.action}</td>
                <td className="p-2 text-cream/70">{a.entity_type} · <span className="font-mono text-[10px]">{a.entity_id.slice(0, 8)}…</span></td>
                <td className="p-2 text-cream/70">{a.reason || "—"}</td>
                <td className="p-2"><span className={`chip text-[9px] ${a.severity === "critical" ? "border-red-400/40 text-red-300" : a.severity === "high" ? "border-gold text-gold" : ""}`}>{a.severity}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
